import { forwardRef } from "react";

import { twMerge } from "@/utils/twMerge";

import type { ComponentPropsWithoutRef } from "react";

type Props = ComponentPropsWithoutRef<"input"> & {
  asInput?: boolean;
};

export const FormToggle = forwardRef<HTMLInputElement, Props>(function FormToggle(
  { checked, className, disabled, asInput = false, ...props }: Props,
  ref,
) {
  return (
    <div
      className={twMerge(
        "relative flex items-center rounded-full w-[36px] min-w-[36px] h-[20px] min-h-[20px] px-[3.5px]",
        checked ? "bg-blue-500" : "bg-gray-400 dark:bg-gray-600",
        // The focused input is transparent, so the ring goes on the track it covers
        "has-[:focus-visible]:outline-solid has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-blue-500",
        className,
      )}
    >
      <div
        className={twMerge(
          "rounded-full w-[13px] h-[13px] bg-white transition-transform duration-75 motion-reduce:transition-none",
          checked ? "translate-x-[16px]" : "translate-x-0",
        )}
      />
      {asInput && (
        <input
          ref={ref}
          type="checkbox"
          role="switch"
          checked={checked}
          disabled={disabled}
          className={twMerge(
            "absolute left-0 top-0 w-full h-full opacity-0 cursor-pointer",
            disabled && "cursor-default",
          )}
          {...props}
        />
      )}
    </div>
  );
});
